(function () {
  'use strict';

  angular
    .module('flightCargo')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flightCargo', {
        url: '/flight-cargo',
        views: {
          'flightCargoView': {
            templateUrl: 'flight-cargo/views/flight-cargo.tpl.html',
            controller: 'FlightCargoCtrl',
            controllerAs: 'flightCargo'
          }
        }
      });
  }
}());
